import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Msg = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userStr = localStorage.getItem("erpUser");
  const user = userStr ? JSON.parse(userStr) : null;
  const userId = user?.userid || user?.id;
  const navigate = useNavigate();

  useEffect(() => {
    if (!userId) {
      setError("Silakan login terlebih dahulu");
      setLoading(false);
      return;
    }

    const fetchUnreadMessages = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `https://api.kamulyaan.id/msg?user_id=${userId}&is_read=false&limit=50`
        );

        let msgList = res.data?.data ?? res.data ?? [];

        // Force to array (handles single object or null response)
        if (!Array.isArray(msgList)) {
          msgList = msgList ? [msgList] : [];
        }

        setMessages(msgList);
      } catch (err) {
        console.error("Gagal memuat pesan belum dibaca:", err);
        setError("Gagal memuat pesan belum dibaca");
        setMessages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUnreadMessages();
  }, [userId]);

  const markAsRead = async (messageId) => {
    if (!messageId) return;

    try {
      await axios.post("https://api.kamulyaan.id/msg/mark-read", {
        message_id: messageId,
        user_id: userId, // safer
      });

      // Update UI instantly
      setMessages((prev) =>
        prev.map((m) => (m.id === messageId ? { ...m, is_read: 1 } : m))
      );
    } catch (err) {
      console.error("Gagal tandai dibaca:", err);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-gray-600">Memuat pesan belum dibaca...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="bg-red-50 p-6 rounded-xl text-center max-w-md">
          <p className="text-red-600 font-medium">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Pesan Belum Dibaca</h1>

      {messages.length === 0 ? (
        <div className="text-center py-20 text-gray-500 bg-gray-50 rounded-xl">
          <p>Semua pesan sudah dibaca atau belum ada notifikasi baru</p>
        </div>
      ) : (
        <div className="space-y-4">
          {messages.map((msg) => (
            <div
              key={msg.id}
              onClick={() => {
                if (!msg.is_read) {
                  markAsRead(msg.id);
                }
                navigate(-1);
              }}
              className={`p-5 rounded-xl border transition-all cursor-pointer hover:shadow-sm ${
                msg.is_read
                  ? "bg-white border-gray-200 opacity-70"
                  : "bg-blue-50 border-blue-200 hover:bg-blue-100"
              }`}
            >
              <div className="flex justify-between items-start gap-4">
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900">
                    {msg.title || "Notifikasi Sistem"}
                  </h3>
                  <p className="mt-1.5 text-gray-700 whitespace-pre-line">
                    {msg.message}
                  </p>
                  {msg.order_id && (
                    <p className="mt-2 text-sm text-blue-600">
                      Pesanan #{msg.order_id}
                    </p>
                  )}
                </div>
                <span className="text-xs text-gray-500 whitespace-nowrap">
                  {new Date(msg.created_at).toLocaleString("id-ID", {
                    dateStyle: "medium",
                    timeStyle: "short",
                  })}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Msg;